if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
        super();
        
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartItems = document.querySelector('cart-items');
        this.submitButton = this.querySelector('[type="submit"]');
    }


    onSubmitHandler(evt) {

    evt.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
    
    this.handleErrorMessage();
    
    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    this.querySelector('.loading-overlay__spinner').classList.remove('hidden');



    let isUpsell = false;
 
    if (typeof this.form.dataset.isupsell !== "undefined" &&  this.form.dataset.isupsell == 'true') {
        isUpsell = true;
  
    };


    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    
    const formData = new FormData(this.form);
    formData.append('sections', this.cartItems.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
    config.body = formData;
    
    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
    if (response.status) {
    this.handleErrorMessage(response.description);
    
    const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
    if (!soldOutMessage) return;
    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.querySelector('span').classList.add('hidden');
    soldOutMessage.classList.remove('hidden');
    this.error = true;
    return;
    }
    
    this.error = false;
    const quickAddModal = this.closest('quick-add-modal');
    if (quickAddModal) {
    document.body.addEventListener('modalClosed', () => {
    setTimeout(() => { this.cartItems.renderContents(response) });
    }, { once: true });
    quickAddModal.hide(true);
    } else {
    this.cartItems.renderContents(response);
    }
    if (!isUpsell) {
        this.cartItems.viewDrawer();
    }
        
    
    })
    
    .catch((e) => {
    console.error(e);
    })
    .finally(() => {
    this.submitButton.classList.remove('loading');
    if (!this.error) this.submitButton.removeAttribute('aria-disabled');
    this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    });
    }
    
    handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
    
    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
    
    if (errorMessage) {
    this.errorMessage.textContent = errorMessage;
    }
    }
    });
    }